import App from './login/index.svelte'

const app = new App({
  hydrate: true,
  target: document.querySelector('#app')
})
